import { _userLevel } from 'ecp/models/UsersModel'

const TypistModels = {
  showPromotersFilter: (userLevel: _userLevel) => ['master'].includes(userLevel)
}

export default TypistModels
